app.service('warrantyEncouragement', function (console, front, modal, loading, pageConfig, warrantyQuestionnaire, confirmCartRecalculateModal) {

	var $self, $buttons, $encouragement, $moreInfo, $description, $warrantyPaymentTypeSelector, $warrantyQuantitySelector, $noSelectedWarrantyBox;
	var addedWarrantyId, addedWarrantyVariant, selectedWarrantyId, selectedQuantity, addedQuantity;
	var $subscriptionBenefits;
	var returnCallback;
	var showGradeInfoFromCart, categoryGradeInfoFromCart;
	var config;

	var selectedWarrantyVariant = ''; // default value

	function setElements() {
		$self = $('#warranty-encouragement-modal');

		$encouragement = $('#warranty-encouragement', $self);
		$description = $('#warranty-description', $self);
		$grades = $('#warranty-grades', $self);
		$buttons = $('.js-add-warranty-button', $encouragement);
		$moreInfo = $('.js-warranty-info', $encouragement);
		$gradeInfo = $('.js-warranty-grades-info', $encouragement);
		$warrantyPaymentTypeSelector = $('.warraty-type-select input.js-customic-select-input', $self);
		$warrantyQuantitySelector = $('.warraty-quantity-select input.js-customic-select-input', $self);
		$noSelectedWarrantyBox = $(`.no-selected-warranty`, $self);
		addedWarrantyId = $encouragement.data('added-warranty-id');
		addedWarrantyVariant = $encouragement.data('added-warranty-type');
		addedQuantity = $warrantyQuantitySelector.length ? $warrantyQuantitySelector.val() / 1 : 1;
		selectedWarrantyVariant = $encouragement.data('selected-type');
		selectedWarrantyId = $encouragement.data('selected-id') ? $encouragement.data('selected-id') / 1 : false;
		$warratyBox = $('.encouragement-box', $encouragement);
		$subscriptionBenefits = $('.subscription-benefits', $encouragement);
		selectedQuantity = addedQuantity;
		config = pageConfig.getData('order');
		if (showGradeInfoFromCart) {
			$self.addClass('show-warranty-grades-info-from-list');
			showWarrantyCategoryRating(categoryGradeInfoFromCart);
			UA.interaction('Potykacz Gwarancyjny - K1', 'Gwiazdki PG - warstwa ze szczególami', 'Wyświetlenie');
		} else {
			$self.removeClass('show-warranty-grades-info-from-list');
		}
		if (config.isOperatorMode) {
			warrantyQuestionnaire.markAnswers('#warranty-encouragement-modal');
		}
	}

	function showWarrantyCategoryRating(warrantyCategory) {
		$('.warranty-grade-rating-item', $self).removeClass('show');
		$self.find(`.warranty-grade-rating-item[data-warranty-category="${warrantyCategory}"]`).addClass('show');
	}

	function changeWarrantyPaymentType(warrantyPaymentType) {
		selectedWarrantyVariant = warrantyPaymentType;
		if (selectedWarrantyId) {
			let $newSelected = $buttons.filter(`[data-warranty-type=${warrantyPaymentType}][data-warranty-id=${selectedWarrantyId}]`);
			if ($newSelected.length) {
				console.log('udana zmiana gwarancji');
				$buttons.removeClass('selected');
				$newSelected.addClass('selected');
				$noSelectedWarrantyBox.removeClass('is-active');
			} else {
				console.log('nieudana zmiana gwarancji');
				$noSelectedWarrantyBox.addClass('is-active');
			}
		}
		$encouragement.attr('data-selected-type', warrantyPaymentType);
		checkHeight();

	}
	function checkHeight() {
		var $box = $warratyBox.filter('[data-warranty-payment-type="' + selectedWarrantyVariant + '"]');
		var $features = $('.warranty-features', $box);
		//console.log(selectedWarrantyVariant, $box.length, $features.length)
		var height = 0;
		$features.each(function () {
			height = Math.max(height, $(this).height());
		}).css('min-height', height);
	}

	function setEvents() {

		$warrantyPaymentTypeSelector.on('change', function () {
			changeWarrantyPaymentType($(this).val());
		});
		$warrantyQuantitySelector.on('change', function () {
			selectedQuantity = $(this).val();
		});

		$buttons.on('click', function (event) {
			$noSelectedWarrantyBox.removeClass('is-active');
			$encouragement.addClass('change-warranty');
			if (!event.target.closest(`.js-show-tooltip`)) {
				// resetowanie prezentowanych wszystkich benefitow abonamentowych do domyślnych
				$subscriptionBenefits.removeClass('is-visible');
				$subscriptionBenefits.filter('.default').addClass('is-visible');
				if ($(this).hasClass('selected')) {
					$encouragement.removeClass('selected');
					$(this).removeClass('selected');
					selectedWarrantyId = false;
					selectedWarrantyVariant = false;
				} else {
					$buttons.removeClass('selected');
					$encouragement.addClass('selected');
					$(this).addClass('selected');
					selectedWarrantyId = $(this).data('warranty-id');
					selectedWarrantyVariant = $(this).data('warranty-type');
					// prezentowanie benefitow abonamentowych (w ramach wariantu) dla wybranej gwarancji abonamentowej
					$(this).closest('.warranty-item').find('.subscription-benefits').removeClass('is-visible')
						.filter('[data-benefit-warranty-id="' + $(this).data('warranty-id') + '"]').addClass('is-visible');
				}
			}
		});

		$moreInfo.on('click', function () {
			const warrantyType = $(this).data('warranty-type');
			const warrantyId = $(this).data('warranty-id');
			$self.addClass('show-description');
			$('.warranty-item', $description).removeClass('visible');
			$(`.warranty-info-${warrantyId}`, $description).filter(`[data-warranty-type=${warrantyType}]`).addClass('visible');
		});

		$gradeInfo.on('click', function () {
			$self.addClass('show-warranty-grades-info');
			showWarrantyCategoryRating($(this).data('warranty-category'));
			UA.interaction('Potykacz Gwarancyjny - K1', 'Gwiazdki przy wariancie PG', 'Kliknięcie');
		});

		$('.js-features-more', $encouragement).on('click', function () {
			$(this).remove();
		});

		$('.js-warranty-back-button', $description).on('click', function () {
			$self.removeClass('show-description');
		});

		$('.js-warranty-back-button', $grades).on('click', function () {
			$self.removeClass('show-warranty-grades-info');
			UA.interaction('Potykacz Gwarancyjny - K1', 'Gwiazdki PG - warstwa ze szczególami', 'Zamknięcie');
		});

		$('.js-add-warranty', $encouragement).on('click', function () {
			if (selectedWarrantyId && selectedWarrantyVariant && !$noSelectedWarrantyBox.hasClass('is-active')) {
				if (!(addedWarrantyId && addedWarrantyVariant)) {
					// nowa
					returnCallback('ADD', {
						warrantyPaymentType: selectedWarrantyVariant,
						warrantyId: selectedWarrantyId,
						quantity: selectedQuantity
					});
				} else if (addedWarrantyId != selectedWarrantyId || addedWarrantyVariant != selectedWarrantyVariant || selectedQuantity != addedQuantity) {
					//zmiana
					const callbackToReturn = function () {
						returnCallback('UPDATE', {
							warrantyPaymentType: selectedWarrantyVariant,
							warrantyId: selectedWarrantyId,
							quantity: selectedQuantity
						});
					}
					if (config.productIdForInstalmentProductWithWarranty.length) {
						confirmCartRecalculateModal.show(function () {
							callbackToReturn();
						});
					} else {
						callbackToReturn();
					}
				}
				else {
					// zaznaczona ta sama
				}
			} else if (addedWarrantyId && addedWarrantyVariant) {
				//usuwamy
				const callbackToReturn = function () {
					returnCallback('REMOVE', {
						warrantyId: addedWarrantyId,
						warrantyPaymentType: addedWarrantyVariant
					});
				}
				if (config.productIdForInstalmentProductWithWarranty.length) {
					confirmCartRecalculateModal.show(function () {
						callbackToReturn();
					});
				} else {
					callbackToReturn();
				}
			} else {
				// nie było i nic się nie zmieniło
			}
			modal.close();
		});
	}

	function load(obj) {
		returnCallback = obj.callback || null;
		showGradeInfoFromCart = obj.showGradeInfoFromCart || null;
		categoryGradeInfoFromCart = obj.categoryGradeInfoFromCart || null;

		var url = '/warrantyModal.ltr';
		loading.start();
		$.ajax({
			url: url,
			data: {
				productId: obj.productId || undefined,
				packageIdentifier: obj.packageIdentifier || undefined,
				relatedPromotionIdentifier: obj.relatedPromotionIdentifier || undefined,
				variant: obj.variant || undefined,
				defaultSelectedWarranty: obj.defaultSelectedWarranty || undefined
			},
			success: function (html) {
				loading.stop();
				loadSuccess(html);
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd ładowania gwarancji. Spróbuj ponownie później.');
			}
		});
	}

	function loadSuccess(data) {
		modal.generate({
			content: data,
			id: 'warranty-encouragement-modal',
			callbackOpen: function () {
				loadSuccessCallbackOpen();
			},
			callbackClose: function () {
				if (config.isOperatorMode) {
					warrantyQuestionnaire.markAnswers();
				}
			}
		});
	}

	function loadSuccessCallbackOpen() {
		setElements();
		setEvents();
		checkHeight();
		UA.pageview("/akcje/potykacz-gwarancyjny/wyswietl-" + front.page());
		if(addedWarrantyId || selectedWarrantyId){
			$encouragement.addClass('change-warranty');
		}
	}

	return {
		load
	};
});
